module.exports = __webpack_public_path__ + "img/ic_body_type.4b3b09c7.svg";